export const CHAT_MAX_HEIGHT = 640;

export const isDeviceHeightBelow = (height) => {
  return window.innerHeight < height;
};
